import { xor as _xor } from "lodash/fp";
export default (array, element) => _xor(array, [element]);
